export const JOB_TYPES = {
  MANUAL: 'manually',
  AUTOMATIC: 'automatically',
  AMC: 'amc',
}
